import type { StudentResultExercise } from "../../../../helpers/StudentResultModel";
import { getTeacherCommentTone } from "../../../../constants/StudentResultCommentTones";
import StudentResultAnswerBox from "../StudentResultAnswerBox";
import StudentResultAnswerCheck from "../StudentResultAnswerCheck";
import StudentResultAnswerRow from "../StudentResultAnswerRow";

interface StudentResultAnswersTextProps {
    exercise: StudentResultExercise;
}

/**
 * Text tasks, with or without a word box. Evaluation normalises the text into one synthetic answer
 * row whose question is a sentinel id ("tO"/"jw"), so the question is never shown here. The
 * exercise is scored as a whole, so the card's own label carries the points rather than the row.
 */
const StudentResultAnswersText = (props: StudentResultAnswersTextProps) => {
    return (
        <ul
            className="flex flex-col"
            data-testid="student-result-answers-text"
        >
            {props.exercise.answers.map((answer, index) => (
                <StudentResultAnswerRow
                    key={answer.id}
                    isLast={index === props.exercise.answers.length - 1}
                    comment={answer.teacherComment}
                    tone={getTeacherCommentTone(answer.state)}
                >
                    <div className="flex items-start gap-s">
                        <StudentResultAnswerBox
                            state={answer.state}
                            text={answer.studentAnswer}
                            isMultiline
                        />
                        <StudentResultAnswerCheck state={answer.state} />
                    </div>
                </StudentResultAnswerRow>
            ))}
        </ul>
    );
};

export default StudentResultAnswersText;
